import config from "../config";
import type { APIConfigType } from "./types";

const { baseApiURL } = config;

const tourBaseUrl = `${baseApiURL}tour/v1/`;
const tourBaseUrlV1o1 = `${baseApiURL}tour/v1.1/`;
const clientTourBaseUrl = "/api/tour/";

const API_CONFIG = {
  availability: `${tourBaseUrlV1o1}availability`,
  airportByIata: `${tourBaseUrl}airportByIata`,
  showCities: `${tourBaseUrl}cities/show`,
  detail: `${tourBaseUrlV1o1}detail`,
  detailByKey: (key: string) => `${tourBaseUrl}package/${key}/show`,
  accommodations: (key: string) =>
    `${tourBaseUrlV1o1}accommodations/${key}/info`,
  storePassengers: {
    client: `${clientTourBaseUrl}passengers/`,
    back: `${tourBaseUrlV1o1}passenger/store`,
  },
  getPassengers: (passengerKey: string) =>
    `${tourBaseUrlV1o1}passenger/${passengerKey}`,
  cities: {
    client: `${clientTourBaseUrl}cities`,
    back: `${tourBaseUrl}cities`,
  },
  check: {
    client: `${clientTourBaseUrl}check`,
    back: `${tourBaseUrl}check`,
  },
  book: {
    client: `${clientTourBaseUrl}book`,
    back: `${tourBaseUrl}order/book`,
  },
  calculatePrice: {
    client: `${clientTourBaseUrl}calculatePrice`,
    back: `${tourBaseUrlV1o1}calculate-price?lang=fa`,
  },
};

export const TOUR_API_CONFIG: APIConfigType<typeof API_CONFIG> = API_CONFIG;
